import Typography from "@/components/typography/Typography"
import { useBreakpoint } from "@/hooks/useBreakpoint"
import { LinedTitle } from "@/pages/website-landing/components/lined-title/LinedTitle"
import { Col, Row } from "antd"
import { FC } from "react"
import "./WhatMatters.less"
import gearsImg from "./assets/gears.png"
import moneyImg from "./assets/money.png"
import searchImg from "./assets/search.png"
import thumbUpImg from "./assets/thumb-up.png"
import warningImg from "./assets/warning.png"

const { Title, Paragraph } = Typography

const whatMattersCardContent = [
  {
    image: gearsImg,
    text: "Unaffected Applications\nWere Automatically\nProcessed?",
    type: "vertical",
  },
  {
    image: searchImg,
    text: "Potential Infrastructure Risks\nWere Automatically\nIdentified?",
    type: "vertical",
  },
  {
    image: thumbUpImg,
    text: "Your Team Only Reviewed\nApplications That Actually\nRequired Attention?",
    type: "vertical",
  },
  {
    image: moneyImg,
    text: "More Resources Could Be Redirected Towards Network Expansion and Revenue\nGenerating Projects?",
    type: "horizontal",
  },
  {
    image: warningImg,
    text: "Infrastructure Damage Risk\nCould Be Significantly\nReduced?",
    type: "horizontal",
  },
]

const WhatMatters: FC = () => {
  const { xxl, xl, lg, md, sm } = useBreakpoint()

  return (
    <div className={"what-matters-wrapper"}>
      <div className={"container"}>
        <Row justify={"center"}>
          <Col span={24} style={{ paddingBottom: 40 }}>
            <Title level={xxl || xl || lg || md || sm ? 2 : 3} color={"white"} centered className={"title"}>
              <span className={"w300"}>{"What If Your Team Could Focus Only\non  "}</span>
              <span className={"orange-bold"}>{"What Matters?"}</span>
            </Title>
          </Col>
          <Col span={24} style={{ paddingBottom: 40 }}>
            <LinedTitle text={"What if:"} />
          </Col>
          <Col span={24}>
            <Row justify={"center"} gutter={[24, 24]}>
              {whatMattersCardContent &&
                whatMattersCardContent.map((card, index) => (
                  <Col
                    key={index}
                    xxl={card.type === "horizontal" ? 12 : 8}
                    xl={card.type === "horizontal" ? 12 : 8}
                    lg={card.type === "horizontal" ? 12 : 8}
                    md={card.type === "horizontal" ? 12 : 8}
                    sm={12}
                    xs={24}
                  >
                    <div
                      className={`what-matters-card-wrapper ${
                        card.type === "horizontal" && (xxl || xl || lg || md) ? "horizontal" : ""
                      }`}
                    >
                      <div className={"what-matters-img-wrapper"}>
                        <img src={card?.image} alt={""} loading={"lazy"} decoding={"async"} />
                      </div>

                      <div className={"divider"} />

                      <div className={"what-matters-text-box"}>
                        <Paragraph
                          centered
                          color={"website-secondary"}
                          lh={"lh-lg"}
                          size={xxl || xl || lg ? "lg" : "md"}
                          weight={"w300"}
                        >
                          {card?.text}
                        </Paragraph>
                      </div>
                    </div>
                  </Col>
                ))}
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default WhatMatters
